import { addressSelectionUI } from 'platform/shared/health-apps';
import { DEFAULT_TITLE_OPTS, titleWithNameUI } from '../../definitions';
import content from '../../locales/en/content.json';

const TITLE_TEXT = content['address-selection--page-title'];
const DESC_TEXT = content['address--page-description'];
const INPUT_LABEL = content['applicants--address-label'];

export default {
  uiSchema: {
    ...titleWithNameUI(TITLE_TEXT, DESC_TEXT, DEFAULT_TITLE_OPTS.applicant),
    'view:applicantSharedAddress': addressSelectionUI({
      title: INPUT_LABEL,
      destinationKey: 'applicantAddress',
      sourceKeys: ['applicants.applicantAddress', 'sponsorAddress'],
    }),
  },
  schema: {
    type: 'object',
    required: ['view:applicantSharedAddress'],
    properties: {
      'view:applicantSharedAddress': { type: 'string' },
    },
  },
};
